<template>
    <toolbar-option type="stacked" :message="message">
        <template slot="primary">
            <dropdown
                :value="selected"
                :options="options"
                native
                @input="onInput"
            />
        </template>
    </toolbar-option>
</template>

<script>
import gql from 'graphql-tag';
import baseOption from '@/options/mixins/base-option';

export default {
    name: 'carousel-promo-data-source',
    mixins: [baseOption],

    apollo: {
        carouselItems: {
            query: gql`
                {
                    item(path: "/sitecore/content/Data/Global/Carousels/Carousel Promo/Carousel") {
                        children {
                            id
                            name
                        }
                    }
                }
            `,
            update(data) {
                if (!data || !data.item) return [];

                return data.item.children;
            },
        },
    },

    data() {
        return {
            displayName: 'Data Source',
            message: '* A data source must be selected from items in /sitecore/content/Data/Global/Carousels/Carousel Promo/Carousel',
            selected: '',
        };
    },

    computed: {
        options() {
            const noneOption = { text: 'None', value: '' };

            if (!this.carouselItems) return [noneOption];

            return [
                noneOption,
                ...this.carouselItems.map(item => ({ text: item.name, value: item.id })),
            ];
        },
    },

    watch: {
        carouselItems() {
            if (!this.carouselItems) return;

            this.onSelectedElement();
        },
    },

    methods: {
        async onInput(selected) {
            this.selected = selected;
            this.selectedElements.forEach(elem => elem.setElementData('carousel-promo-data-source', selected));
        },

        onSelectedElement() {
            this.selected = this.selectedElements[0].getElementData('carousel-promo-data-source') || '';
        },
    },
};
</script>
